(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["card-size-picker"] && !Shopify.designMode) return;
  try {
    // Loaded once for the whole page (Shopify bundles this block-level JS).
  // We deliberately avoid emitting a script tag inside each card: on iOS/WebKit
  // a script element inside every carousel slide broke the RTL scroll-snap
  // initialization, making the best-sellers carousel start at the wrong end.
  class CardSizePicker extends HTMLElement {
    connectedCallback() {
      // Only react to user interaction — never mutate the DOM on load (the
      // server already renders the correct default price/link, and mutating
      // inside a scroll-snap carousel can make it re-snap).
      this.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    onChange = (event) => {
      const input = event.target;
      if (input instanceof HTMLInputElement && input.classList.contains('card-size-picker__input')) {
        this.apply(input);
      }
    };

    apply(input) {
      const card = this.closest('product-card');
      if (!card) return;

      const price = input.dataset.price;
      const compare = input.dataset.compare;
      const url = input.dataset.url;
      const available = input.dataset.available === 'true';

      const container = Array.from(card.querySelectorAll("product-price [ref='priceContainer']"))
        .filter((el) => !el.closest('dialog, quick-add-modal, .quick-add-modal'))
        .pop();

      if (container && price) {
        container.querySelectorAll('.price').forEach((el) => { el.textContent = price; });
        const hasCompare = Boolean(compare && compare.trim() && compare !== price);
        const regular = container.querySelector('.price__regular');
        const sale = container.querySelector('.price__sale');
        if (regular && sale) {
          regular.classList.toggle('price__hidden', hasCompare);
          sale.classList.toggle('price__hidden', !hasCompare);
        }
        if (hasCompare) {
          container.querySelectorAll('.compare-at-price').forEach((el) => { el.textContent = compare; });
        }
      }

      if (url) {
        card.querySelectorAll('a.product-card__link, a[ref="productCardLink"]').forEach((a) => {
          try { a.href = url; } catch (e) { /* noop */ }
        });
      }

      const atc = card.querySelector('.add-to-cart__button button, .add-to-cart button, button[name="add"]');
      if (atc instanceof HTMLButtonElement) atc.disabled = !available;
    }
  }

  if (!customElements.get('card-size-picker')) {
    customElements.define('card-size-picker', CardSizePicker);
  }
  } catch(e) { console.error(e); }
})();

})();
